import React, { useCallback, useEffect, useState } from "react";
import styles from "./responsiveImg.scss";
import FallbackImg from "../../assets/images/fallbackImg.png";

function ResponsiveImg(props) {
  const { src, showFallbackImg, bestQuality, ...other } = props;
  const [isError, setIsError] = useState(false);
  const [containerWidth, setContainerWidth] = useState();
  const [srcAndQueryStr, setSrcAndQueryStr] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  const handleError = () => {
    const qs = srcAndQueryStr ? srcAndQueryStr.split("?")[1] : "";
    const format = new URLSearchParams(qs).get("format");
    const jpgUsed = format == "jpg";

    if (!jpgUsed) {
      setSrcAndQueryStr(getSrcAndQueryString("jpg"));
      return;
    }
    setIsError(true);
  };

  const handleLoad = () => {
    setIsLoaded(true);
  };

  const imgRef = useCallback((node) => {
    if (!node) return;
    const cv = node.getBoundingClientRect().width;
    setContainerWidth(Math.max(cv, 300));
  }, []);

  const getSrcAndQueryString = (format) => {
    if (bestQuality)
      return `${src}?${new URLSearchParams({
        format,
      }).toString()}`;

    if (containerWidth != null)
      return `${src}?${new URLSearchParams({
        format,
        quality: 100,
        ...(containerWidth > 0 && { width: containerWidth }),
      }).toString()}`;

    return `${src}?${new URLSearchParams({
      format,
    }).toString()}`;
  };

  useEffect(() => {
    setSrcAndQueryStr(getSrcAndQueryString("webp"));
  }, [src, bestQuality, containerWidth]);

  return (
    <div
      className={styles["img-wrapper"]}
      style={
        !isLoaded || isError ? { backgroundImage: `url(${FallbackImg})` } : {}
      }
    >
      <img
        src={srcAndQueryStr}
        onError={!isError ? handleError : undefined}
        onLoad={handleLoad}
        style={isError ? { opacity: 0 } : {}}
        ref={imgRef}
        {...other}
      />
    </div>
  );
}

ResponsiveImg.defaultProps = {
  src: "",
};

export default ResponsiveImg;
